(function () {
  var SECTION_SELECTOR = '.oddit-section-key-traits-band';
  var sectionState = new Map();

  // Build a multi-cycle sine wave (a "roller coaster" of peaks and troughs)
  // centered vertically, as a polyline across the full pixel width. The number
  // of humps scales with the width so it always reads as several curves.
  function buildWavePath(width, height) {
    var midY = height / 2; // wave oscillates around the vertical center
    var amp = height * 0.26; // peak/trough depth — leaves room for the letters
    // Phones get a single gentle peak + trough (two humps); larger screens scale
    // the hump count with width (~one hump per 720px).
    var cycles =
      width < 750 ? 1 : Math.max(2, Math.round(width / 720));
    var step = 8;
    var d = '';
    for (var x = 0; x <= width; x += step) {
      var y = midY + amp * Math.sin((2 * Math.PI * cycles * x) / width);
      d += (d ? ' L' : 'M') + x.toFixed(1) + ' ' + y.toFixed(1);
    }
    // Guarantee the final point lands exactly on the right edge.
    var endY = midY + amp * Math.sin(2 * Math.PI * cycles);
    d += ' L' + width.toFixed(1) + ' ' + endY.toFixed(1);
    return d;
  }

  function repeatPhrase(phrase, times) {
    var out = '';
    for (var i = 0; i < times; i++) out += phrase;
    return out;
  }

  function initMarquee(section) {
    var svg = section.querySelector('[data-trait-svg]');
    var path = section.querySelector('[data-trait-path]');
    var textEl = section.querySelector('[data-trait-text]');
    var textPath = section.querySelector('[data-trait-textpath]');
    if (!svg || !path || !textEl || !textPath) return null;

    var phrase = textEl.getAttribute('data-trait-phrase') || textPath.textContent;
    var duration =
      (parseFloat(svg.getAttribute('data-trait-speed')) || 30) * 1000; // ms

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Animation state, preserved across pause/resume so there is no jump.
    var unitLen = 0; // px advance of one phrase
    var velocity = 0; // px per ms
    var elapsed = 0;
    var last = null;
    var rafId = null;
    var running = false;

    function applyOffset() {
      if (!unitLen) return;
      // Move the text left -> right: sweep startOffset from -unitLen up to 0 and
      // wrap. The one-phrase lead-in keeps the whole line covered with no gap.
      var offset = ((elapsed * velocity) % unitLen) - unitLen;
      textPath.setAttribute('startOffset', offset.toFixed(2));
    }

    function layout() {
      var rect = svg.getBoundingClientRect();
      var width = Math.round(rect.width);
      var height = Math.round(rect.height);
      if (!width || !height) return;

      // Pixel-exact viewBox => 1 user unit == 1px, so the font renders crisp and
      // undistorted regardless of viewport width.
      svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
      path.setAttribute('d', buildWavePath(width, height));

      // Measure a single phrase, then repeat it enough to always cover the whole
      // path (plus one spare phrase) so the loop never reveals a gap.
      textPath.textContent = phrase;
      unitLen = textPath.getComputedTextLength();
      if (!unitLen) return;

      var pathLen = path.getTotalLength();
      var repeats = Math.ceil(pathLen / unitLen) + 2;
      textPath.textContent = repeatPhrase(phrase, repeats);

      velocity = unitLen / duration;
      applyOffset();
    }

    function tick(ts) {
      if (last != null) elapsed += ts - last;
      last = ts;
      applyOffset();
      rafId = window.requestAnimationFrame(tick);
    }

    function play() {
      if (running) return;
      running = true;
      last = null;
      rafId = window.requestAnimationFrame(tick);
    }

    function pause() {
      running = false;
      if (rafId) window.cancelAnimationFrame(rafId);
      rafId = null;
    }

    function syncPlayState() {
      if (reducedMotion.matches || document.hidden) {
        pause();
      } else {
        play();
      }
    }

    // Glyph widths shift once the brand webfont loads, so re-measure then.
    function start() {
      layout();
      syncPlayState();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          layout();
        });
      }
    }

    start();

    var ro = new ResizeObserver(function () {
      layout();
    });
    ro.observe(svg);

    function handleReducedMotion() {
      syncPlayState();
    }
    if (typeof reducedMotion.addEventListener === 'function') {
      reducedMotion.addEventListener('change', handleReducedMotion);
    }

    function handleVisibility() {
      syncPlayState();
    }
    document.addEventListener('visibilitychange', handleVisibility);

    return {
      pause: pause,
      ro: ro,
      reducedMotion: reducedMotion,
      handleReducedMotion: handleReducedMotion,
      handleVisibility: handleVisibility,
    };
  }

  function destroyMarquee(state) {
    if (!state) return;
    if (state.pause) state.pause();
    if (state.ro) state.ro.disconnect();
    if (
      state.reducedMotion &&
      typeof state.reducedMotion.removeEventListener === 'function'
    ) {
      state.reducedMotion.removeEventListener('change', state.handleReducedMotion);
    }
    document.removeEventListener('visibilitychange', state.handleVisibility);
  }

  function initSection(section) {
    var state = { marquee: initMarquee(section) };
    sectionState.set(section.id || section, state);
  }

  function destroySection(section) {
    var key = section.id || section;
    var state = sectionState.get(key);
    if (!state) return;
    destroyMarquee(state.marquee);
    sectionState.delete(key);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector
      ? e.target.querySelector(SECTION_SELECTOR)
      : null;
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector
      ? e.target.querySelector(SECTION_SELECTOR)
      : null;
    if (section) destroySection(section);
  });
})();
